import script from "./ClientSchedulingView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientSchedulingView.vue?vue&type=script&setup=true&lang=js"

import "./ClientSchedulingView.vue?vue&type=style&index=0&id=6305f612&lang=css"

const __exports__ = script;

export default __exports__